import { h } from "preact";
import { Link } from "preact-router";
import { IconSvg } from "./iconsvg";
import "./toolicon.scss";

// todo: support for a hover-circle like gmail/material

type Props = {
    icon: string,
    class?: string,
    label?: string,
    tooltip?: string,
    selected?: boolean,
    href?: string,
    disabled?: boolean,
    onClick?: (e: h.JSX.TargetedMouseEvent<HTMLElement>) => void
};

export function ToolIcon(props: Props) {
    if (props.href) {
        // todo: "disabled" not supported
        return (
            <Link href={props.href} className={"component4-toolbar-icon" + (props.class ? ` ${props.class}` : "")} activeClassName="selected" onClick={(props.onClick as any) || undefined} >
                {
                    IconSvg(props.icon)
                }
                {
                    props.label && <span>{props.label}</span>
                }
            </Link>
        );
    }
    return (
        <button className={"component4-toolbar-icon" + (props.selected === true ? " selected" : "") + (props.class ? ` ${props.class}` : "")} disabled={props.disabled} onClick={(props.onClick as any) || undefined} title={props.tooltip}>
            {
                IconSvg(props.icon)
            }
            {
                props.label && <span>{props.label}</span>
            }
        </button>
    );
}